import { useRef, FC, memo } from 'react';
import { SongStatusType } from 'types/song';
import { useUniqueSvgId } from 'app/utils/hooks';
import { Box, Center, useStyleConfig } from '@chakra-ui/react';
import { SystemStyleObject } from '@chakra-ui/styled-system';

export interface SongCoverProps {
  status: SongStatusType;
  size?: 'tiny' | 'small' | 'medium' | 'big' | '38';
  sx?: SystemStyleObject;
}

const SongCoverComponent: FC<SongCoverProps> = ({
  status,
  size = 'big',
  sx,
}) => {
  const style = useStyleConfig('SongCover', { size, status });
  const ref = useRef<SVGSVGElement>(null);
  useUniqueSvgId(ref, `${status}-${size}`);

  return (
    <Center
      sx={{
        ...style,
        ...sx,
      }}
    >
      <Box data-testid="session-song-cover-inner-circle" />
    </Center>
  );
};

export const SongCover = memo(SongCoverComponent);
